import React, { useRef, useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import { Divider, Dropdown } from 'antd';


const Context = React.createContext();

export default function Toolbar(props) {

    const [groups, setGroups] = useState([]);

    useEffect(() => {

        const group = _.groupBy((props.addons || []).filter(c => c.location === props.location), c => c.group);

        let catalogs = [];
        for (const name in group) {
            const items = group[name];
            catalogs.push({ name, items });
        }

        catalogs = _.sortBy(catalogs, c => {
            let max = _.minBy(c.items, d => d.groupIndex !== undefined ? d.groupIndex : 999999999);
            return max.groupIndex || 0;
        });

        setGroups(catalogs);

    }, [props.addons, props.location]);

    const renderDropdownButtonItem = useCallback((c, g) => {

        const items = g.filter(item => item.target === c.name).map((item, index) => {
            return {
                label: <item.Component {...item.props} metadata={item} />,
                key: index + "",
            }
        });

        return <Dropdown.Button  {...c.typeProps} menu={{ items }}>
            <c.Component {...c.props} metadata={c} />
        </Dropdown.Button>

    }, []);

    const renderDropdownItem = useCallback((c, g) => {

        const items = g.filter(item => item.target === c.name).map((item, index) => {
            return {
                label: <item.Component {...item.props} metadata={item} />,
                key: index + "",
            }
        });

        return <Dropdown  {...c.typeProps} menu={{ items, style: { transform: 'translate(-5px 10px)' } }} trigger={"click"}>
            <c.Component {...c.props} metadata={c} />
        </Dropdown>

    }, []);

    const renderItem = useCallback((c, g) => {

        if (c.type === "dropdown-button")
            return renderDropdownButtonItem(c, g);
        else if (c.type === "dropdown")
            return renderDropdownItem(c, g);
        else if (c.target)
            return null;
        else
            return <>
                {c.divider && <Divider type="vertical" />}
                <c.Component {...c.props} metadata={c} />
            </>

    }, []);

    return <>
        {
            groups.map((g, i) => <>
                <div key={i} className='toolgroup'>
                    {
                        g.items.map((c, i) => renderItem(c, g.items))
                    }
                </div>
            </>)
        }
    </>
}